
export default {
    MOVING_ID: 21,
    OFFICE_MOVING_ID: 23,
    KABLUK: 86,
    PORTER_SOBOL: 87,
    GAZEL: 88,
    BICHOK: 89,
    FIVE_TONS_CAR: 90,
    TEN_TONS_CAR: 91,
    TWENTY_TONS_CAR: 92,
};


// WEBPACK FOOTER //
// ./client/constants/Subcategories.js